import { createAudioEngine } from "../audio";
import "../cards/card-face.css";
import { cardFullscreen } from "../cards/CardFullscreen";
import {
  copiesOwned,
  loadCollection,
  ownedVerseIds,
} from "../collection";
import { DeckPicker } from "./DeckPicker";
import { currentDeckBounds, deckSummary } from "./storage";

const PLAY_CAMPAIGN = "/prototypes/proclaim/?mode=campaign";
const PLAY_FREE_HUB = "/freeplay/";

const root = document.getElementById("deck-picker");
const titleEl = document.getElementById("deck-page-title");
const leadEl = document.getElementById("deck-page-lead");
const playCampaign = document.getElementById(
  "deck-play-link",
) as HTMLAnchorElement | null;
const playFree = document.getElementById(
  "deck-play-free",
) as HTMLAnchorElement | null;
const playNote = document.getElementById("deck-play-note");
const tabs = document.getElementById("deck-mode-tabs");

if (!root) throw new Error("Missing #deck-picker");

if (tabs) tabs.remove();

loadCollection();
const bounds = currentDeckBounds();
const ownedKinds = ownedVerseIds();
const ownedN = ownedKinds.length;
let ownedCopies = 0;
for (const id of ownedKinds) ownedCopies += copiesOwned(id);

if (titleEl) {
  titleEl.textContent = "Build & save decks";
}
if (leadEl) {
  leadEl.textContent = `You own ${ownedN} verse type${ownedN === 1 ? "" : "s"} (${ownedCopies} copies). Build loadouts of ${bounds.min}–${bounds.max} cards — you can include multiple copies of a verse up to how many you own. Earn more in campaign · progress stays on this device.`;
}
const fromFreeplay =
  new URLSearchParams(window.location.search).get("from") === "freeplay";
const back = document.getElementById("deck-back") as HTMLAnchorElement | null;
if (fromFreeplay && back) {
  back.href = PLAY_FREE_HUB;
  back.textContent = "← Free play";
}

if (playCampaign) {
  playCampaign.href = PLAY_CAMPAIGN;
  playCampaign.textContent = "Play campaign";
}
if (playFree) {
  playFree.href = PLAY_FREE_HUB;
  playFree.textContent = "Free play";
}

const deckAudio = createAudioEngine({ musicContent: false });
cardFullscreen.setVoPreview({
  play: async (verseId) => {
    await deckAudio.resume();
    return deckAudio.playVerseVo(verseId);
  },
  stop: () => deckAudio.stopVerseVo(),
  isPlaying: (verseId) => deckAudio.isVerseVoPlaying(verseId),
});

function gatePlayLinks(dirty: boolean, valid: boolean): void {
  const { min, max } = currentDeckBounds();
  for (const link of [playCampaign, playFree]) {
    if (!link) continue;
    if (dirty || !valid) {
      link.classList.add("is-gated");
      link.setAttribute("aria-disabled", "true");
      link.title = dirty
        ? "Save your deck before playing"
        : `Pick at least ${min} owned verses and save`;
    } else {
      link.classList.remove("is-gated");
      link.removeAttribute("aria-disabled");
      link.title = "";
    }
  }
  if (playNote) {
    if (dirty) {
      playNote.textContent = "Unsaved changes — Save deck to use this loadout in play.";
      playNote.hidden = false;
    } else if (!valid) {
      playNote.textContent = `Need ${min}–${max} owned verses before you can play.`;
      playNote.hidden = false;
    } else {
      playNote.textContent = "";
      playNote.hidden = true;
    }
  }
}

function blockGatedClick(e: MouseEvent): void {
  const a = e.currentTarget as HTMLAnchorElement;
  if (a.classList.contains("is-gated")) {
    e.preventDefault();
  }
}
playCampaign?.addEventListener("click", blockGatedClick);
playFree?.addEventListener("click", blockGatedClick);

new DeckPicker({
  root,
  onChange: (deck) => {
    document.title = `${deck.name} · ${deck.verseIds.length} cards — Sword of the Spirit`;
    console.info("Deck:", deck.name, deckSummary(deck.verseIds));
    // Endless link uses active loadout; keep query clean
    if (playFree) {
      playFree.href = PLAY_FREE_HUB;
    }
  },
  onDirtyChange: ({ dirty, valid, deckName }) => {
    gatePlayLinks(dirty, valid);
    if (playFree && !dirty && valid) {
      playFree.title = `Open free play with “${deckName}”`;
    }
  },
});
